import { NEW_CHANGE_LABEL, hasUsageTrend, type UsageChange } from "@/lib/usage-comparison";
import { NO_ACTIVITY_THIS_PERIOD } from "@/lib/usage-messages";

function comparisonLabel(comparison: UsageChange, period: string) {
  if (comparison.noActivity) return NO_ACTIVITY_THIS_PERIOD;
  if (!comparison.change) return "Comparison unavailable";
  if (comparison.change === NEW_CHANGE_LABEL) return "New this period";
  return `${comparison.change} vs ${period}`;
}

function comparisonColor(comparison: UsageChange) {
  if (!hasUsageTrend(comparison)) return "text-muted-foreground";
  return comparison.changeType === "increase" ? "text-green-600" : "text-red-600";
}

export function UsageComparison({ comparison, period, loading }: {
  comparison: UsageChange;
  period: string;
  loading?: boolean;
}) {
  if (loading) return <div className="mt-1 h-4 w-24 animate-pulse rounded bg-purple-200/60" aria-hidden="true" />;
  return <p className={`text-xs mt-1 ${comparisonColor(comparison)}`}>{comparisonLabel(comparison, period)}</p>;
}
